// MODULES
import React from "react";
import PropTypes from "prop-types";

// HELPERS
import {createClassName} from "@helpers/utils";
import Checkbox from "../../../../components/Checkbox/Checkbox";


export default class Signatory extends React.PureComponent {
	static propTypes = {
		data: PropTypes.object.isRequired,
		index: PropTypes.number.isRequired,
		selectable: PropTypes.bool.isRequired,
		selectedSignatoriesAmount: PropTypes.number.isRequired,
		onChange: PropTypes.func.isRequired,
	};

	static defaultProps = {
		selectable: true,
		selected: true,
	};

	state = {
		editMode: false,
		isSmsRequested: false
	};

	render() {
		const {props, state} = this;
		const {data, selectable, selectedSignatoriesAmount} = props;
		const classNamePrefix = "Cob-SignAgreement-Signatory";
		const classes = createClassName(classNamePrefix, {
			"edit": state.editMode,
			"selectable": selectable,
			"selected": data.selected === true,
		});

		return (
			<div className={classes}>
				{selectable && (
					<div className={classNamePrefix + "-bar"}>
						<Checkbox
							checked={data.selected !== false}
							disabled={data.selected !== false && selectedSignatoriesAmount <= 1}
							onChange={this._onSelectedChange}
						/>
						<div className={classNamePrefix + "-name"}>{data.firstName + " " + data.lastName}</div>
					</div>
				)}

				{(!selectable || data.selected !== false) && (
					<div className={"Cob-SignAgreement-SignModal-Signatory"}>
						<div className={"row"}>
							<div className={"column"}>
								{data.firstName}
							</div>
							<div className={"column"}>
								{data.lastName}
							</div>
						</div>

						<div className={"row"}>
							<div className={"column"}>
								{data.ssn}
							</div>
							<div className={"column"}>
								{data.phone}
							</div>
						</div>

						<div className={"row"}>
							<div className={"column"}>
								{data.email}
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}

	_onSelectedChange = (selected) => {
		const {data, index, selectedSignatoriesAmount, onChange} = this.props;
		if (data.selected === false || selectedSignatoriesAmount > 1) onChange({...data, selected}, index);
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/SignModal/Signatory.js